import { slugify } from '@techstyle/react-components';
import { urlNoQueryString } from '@techstyle/redux-core';

function createProductSource({ breadcrumbs, urlPath = '' }) {
  const formattedUrlPath = urlNoQueryString(urlPath);
  const isNewProductsPage = /\/(new|new-vip)($|\/)/.test(formattedUrlPath);
  const prefix = isNewProductsPage ? 'browse_new' : 'browse';

  if (
    formattedUrlPath === '/products/new' ||
    formattedUrlPath === '/products/new-vip'
  ) {
    return prefix;
  }

  const activeCategory = breadcrumbs[breadcrumbs.length - 1];
  const categoryLabel = slugify(activeCategory.label);
  return `${prefix}_${categoryLabel}`;
}

export function getProductSource({
  breadcrumbs,
  urlPath,
  productSourceFromRoute,
}) {
  if (productSourceFromRoute) {
    return productSourceFromRoute;
  }
  return createProductSource({ breadcrumbs, urlPath });
}
